import { render } from "./DatabasesMeterTableComponent.vue?vue&type=template&id=65da2c84"
import script from "./DatabasesMeterTableComponent.vue?vue&type=script&lang=js"
export * from "./DatabasesMeterTableComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__